/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

export const FlagsPermissionOutgoingShipmentSTI = {
  permission_sti_enable: new FcsFlag.Flag(false),
  permission_sti_create: new FcsFlag.Flag(false),
  permission_sti_detail_view: new FcsFlag.Flag(false),
  flag_reverse_scan_sti_enable: new FcsFlag.Flag(false)
};

export function initFlagsPermissionOutgoingShipmentSTI() {
  // register flags with namespaces for better grouping
  FcsFlag.register(
    "featureOutgoingShipmentSTI",
    FlagsPermissionOutgoingShipmentSTI
  );
}
